import useHistoryUtils from 'hooks/useHistoryUtils'
import { useJamesApolloQuery } from 'hooks/useJamesApolloQuery'
import useRolesViews from 'hooks/useRolesViews'
import { taskQueryApollo } from 'pages/Tasks/queries'
import routes from 'services/RoutesProvider/routes'
import type { Task } from 'shared/graphql/graphql'
import type { UseTaskDetailsPageProps } from './types'

const useTaskDetailsPage = ({ taskUuid }: UseTaskDetailsPageProps) => {
  const { pushWithRole } = useHistoryUtils()
  const { isOffice: office } = useRolesViews()
  const { data, loading, refetch } = useJamesApolloQuery<{ task: Task }>(taskQueryApollo, {
    variables: { favurUuid: taskUuid, office },
    fetchPolicy: 'no-cache',
    onError() {
      pushWithRole(routes.dashboard)
    },
  })

  return {
    task: data?.task,
    loading,
    refetch,
  }
}

export default useTaskDetailsPage
